/* eslint-disable prefer-destructuring,func-names,react/prop-types  */
import React, { Component } from 'react';
import { Modal } from 'antd';
import KeyManagerCreate from './KeyManagerCreate';

export default (bottle) => {
  bottle.factory('KeyManagerContainer', ({ KeyManagerView }) => class KeyManagerContainer extends Component {
    constructor(props) {
      super(props);
      this.state = {
        modalVisible: false,
        bearerToken: 'unk',
        displayToken: false,
      };
      this.onShowModal = this.onShowModal.bind(this);
      this.onHideModal = this.onHideModal.bind(this);
      this.onCreateToken = this.onCreateToken.bind(this);
      this.onClearLastError = this.onClearLastError.bind(this);
      this.onDisplayToken = this.onDisplayToken.bind(this);
    }

    componentDidMount() {
      this.props.fetchKeys(); // eslint-disable-line
    }


    onDisplayToken() {
      this.setState({ displayToken: true });
    }

    onCreateToken() {
      this.setState(
        { displayToken: false },
        () => {
          this.onShowModal();
          this.props.createKey();  // eslint-disable-line
        },
      );
    }

    onClearLastError() {
      this.props.clearLastError(); // eslint-disable-line
    }

    onShowModal() {
      this.setState({
        modalVisible: true,
      });
    }

    onHideModal() {
      this.setState({
        modalVisible: false,
      });
    }

    get goHome() {
      return () => {
        this.props.history.push('/');
      };
    }

    get isLoading() {
      return this.props.loading;
    }

    render() {
      const {
        keys,
        lastError,
        progress,
      } = this.props;

      const { modalVisible, displayToken } = this.state;

      return (
        <KeyManagerView
          title="Bearer Token Manager"
          goHome={this.goHome}
          columns={this.columns}
          dataSource={keys}
          lastError={lastError}
          progress={progress}
          onCreateKey={this.onCreateToken}
          isLoading={this.isLoading}
        >
          <Modal
            title="Create Bearer Token"
            className="key-manager-create-modal"
            visible={modalVisible}
            onCancel={this.onHideModal}
            footer={null}
          >
            <KeyManagerCreate displayToken={displayToken} onDisplayToken={this.onDisplayToken} />
          </Modal>
        </KeyManagerView>
      );
    }
  });
};
